import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { FnCoreModule } from '../../core/index';
import { FnInputModule } from '../input/index';

import { FnSelectComponent } from './single/fn-select.component';
import { FnMultiSelectComponent } from './multi/fn-multi-select.component';
import { FnTranslateModule } from './../../i18n/index';

export * from './single/fn-select.component';
export * from './multi/fn-multi-select.component';
export  * from './fn-select.model';


/** 
 * Exports the required FnSelectComponent , FnMultiSelectComponent to create single and MulitSelect
 * making them available for import by NgModules that import this module.
 */
@NgModule({
  imports: [CommonModule, FormsModule, NgSelectModule, FnCoreModule, FnInputModule,FnTranslateModule],
  declarations: [FnSelectComponent, FnMultiSelectComponent],
  exports: [FnSelectComponent, FnMultiSelectComponent],
  providers: [],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class FnSelectModule {


}
